export default __webpack_public_path__ + "static/media/office.4188206a.jpeg";